import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Text } from '../components';

function StepDone(props) {
  const { text } = props;

  return (
    <Flex
      flexDirection={['column', 'row']}
      alignItems="center"
      justifyContent="center"
    >
      <img src="/j/images/employee-onboarding/onboarding-done.svg" />
      <Flex flexDirection="column" mt={[50, 0]} ml={[0, 123]}>
        <Text bold fontSize="22px">
          Congratulations
        </Text>
        <Text mt={1}>{text || 'Everything was successfully completed.'}</Text>
      </Flex>
    </Flex>
  );
}

StepDone.defaultProps = {
  text: '',
};

StepDone.propTypes = {
  text: PropTypes.string,
};

export default StepDone;
